import React, { useEffect, useState } from "react";
import ScreenComponent from "./ScreenComponent";
import NavegationBar from "./NavegationBar";
import Firebase from "../../../../assets/Firebase";
import Cookies from 'universal-cookie';

const ScreenEngine = ({ config, cookie}) => {
    const f = new Firebase();
    const cookies = new Cookies();

    useEffect(() => {
        if (cookie) {
            f.getDataResponse(config, config.survey, (data, time) => {
                f.updateResponseStart(config.lang, config.surveyId, config.uid);
                config.popupAlertMod(config.getText("editResponse"), config.getText("editR1"), data, config.getText("editR2"), time, null, null, null, config.getText("editSurvey"));
            })
        }
        else{
            f.updateResponseStart(config.lang, config.surveyId, config.uid);
        }
    }, [])

    const onNavItemSelect = (index) => {
        insert();
        if (index >= 0 && index <= config?.survey?.screens?.length) {
            config.update("currentScreen", index);
        }
    }

    const updateResponses = () => {
        if (config.arrAnswers !== undefined) {
            let currentScreen = getCurrentScreen();
            config.arrAnswers.forEach((answer) => {
                currentScreen.questions.forEach((question) => {
                    if (question.ref.id === answer.questionReference.id) {
                        updateQuestion(question.order, "idAnswer", answer.ref.id)
                    }
                })
            })
        }
    }

    const getCurrentScreen = () => {
        let screens = config?.survey?.screens;
        return screens[config?.currentScreen || 0];
    }

    const updateCurrentScreen = (key, value) => {
        let screens = config?.survey?.screens;
        let currentScreen = screens[config?.currentScreen];
        if (currentScreen) currentScreen[key] = value;

        config.update("survey", {
            ...config?.survey,
            screens: screens,
        })
    }

    const updateQuestion = (questionIndex, key, value) => {
        let currentScreen = getCurrentScreen();
        let questions = currentScreen?.questions;
        let question = questions?.[questionIndex];
        if (question) question[key] = value;

        updateCurrentScreen("questions", questions);
    }

    const updateOptions = (questionIndex, optionIndex, key, value) => {
        let currentScreen = getCurrentScreen();
        let questions = currentScreen?.questions;
        let question = questions?.[questionIndex];
        let options = question["options"][optionIndex];
        if (options) options[key] = value;

        updateCurrentScreen("questions", questions);
    }

    const goBack = () => {
        let currentScreen = config.currentScreen;
        if ((currentScreen - 1) >= 0) {
            config.update("currentScreen", (currentScreen - 1));
        }
    }

    const goForward = () => {
        insert();
        let currentScreen = config.currentScreen;
        if ((currentScreen + 1) <= config?.survey?.screens?.length) {
            config.update("currentScreen", (currentScreen + 1));
        }
    }

    const insert = () => {

        if (cookies.get(config.surveyId) !== undefined) {
            updateResponses();
        }

        let currentScreen = getCurrentScreen();
        for (let i = 0; i < currentScreen.questions.length; i++) {
            let question = config.survey.screens[config.currentScreen].questions[i];
            let selectedOptions = [];
            let freeResponse = null;
            let empty = true;

            for (let index = 0; index < question.options.length; index++) {
                let isSub = false;
                if (question.options[index].selected == true) {
                    let selectedSubOption = [];
                    for (let subindex = 0; subindex < question.options[index].suboptions.length; subindex++) {
                        if(question.options[index].suboptions[subindex].selected == true){
                            selectedSubOption.push({
                                "optionReference": question.options[index].suboptions[subindex].ref,
                                "suboptionsResponses": null
                            });
                            isSub = true;
                        }
                    }
                    if(!isSub){
                        selectedOptions.push({
                            "optionReference": question.options[index].ref,
                            "suboptionsResponses": null
                        });
                        empty = false;
                    }
                    else{
                        selectedOptions.push({
                            "optionReference": question.options[index].ref,
                            "suboptionsResponses": selectedSubOption
                        });
                        empty = false;
                    }
                }
            }

            if (question?.freeResponse != null) {
                freeResponse = question?.freeResponse;
                selectedOptions = null;
                empty = false;
            }

            if (question.idAnswer == "" || question.idAnswer == null) {
                f.insertResponse(config, question, selectedOptions, updateQuestion, i, freeResponse, empty);
            } else {
                f.updateResponse(config, question, selectedOptions, freeResponse, empty);
            }
        }
    }

    const [boolEmail, setBoolEmail] = useState(false);

    const isEmailQuestion = () => {
        let currentScreen = getCurrentScreen();
        let boolean = false;
        for (let i = 0; i < currentScreen.questions.length; i++) {
            let question = config.survey.screens[config.currentScreen].questions[i];
            if (question?.type == "EMAIL") {
                boolean = true;
            }
        }
        if (boolean) {
            setBoolEmail(true);
        }
        else setBoolEmail(false);
    }

    const updateLang = (lang) => {
        config.setLang(lang);
        f.updateLangResponse(config, lang)
    }

    const actions = {
        updateQuestion: updateQuestion,
        updateOptions: updateOptions,
        goBack: goBack,
        goForward: goForward,
        isEmailQuestion: isEmailQuestion,
        updateLang: updateLang,
        updateResponses: updateResponses,
    }

    const getLangIcon = (lang) => {
        try {
            return require(`../../../../assets/images/flag-${lang}.png`);
        } catch (e) {
            return null;
        }
    }

    return (
        <>
            <img src={config.background} style={{ position: "fixed", height: "100vh", width: "100vw", opacity: boolEmail ? 0.3 : 1 }}></img>
            <ScreenComponent config={config} screen={getCurrentScreen()} actions={actions} getLangIcon={getLangIcon} boolEmail={boolEmail} />
            <NavegationBar config={config} currentValue={config?.currentScreen} total={config?.survey?.screens?.length} onNavItemSelect={onNavItemSelect} />
        </>
    );
};

export default ScreenEngine;
